import { useState, useEffect, useRef } from "react";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
// Material Dashboard 2 React base styles
import breakpoints from "assets/theme/base/breakpoints";

import MDButton from "components/MDButton";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { Cancel as CancelIcon, SearchOutlined } from "@mui/icons-material";
import { orange } from "@mui/material/colors";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { InputAdornment, IconButton } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import Swal from "sweetalert2";
import { CircularProgress } from "@mui/material";
import MDTypography from "components/MDTypography";

const ChangePass = ({ changePassOpen, setChangePassOpen }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.adminData.adminData);
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);
  const [open, setOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const inputRef = useRef(null);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [error, setError] = useState(null);
  const [errorPwd, setErrorPwd] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [formData, setFormData] = useState({
    admin_id: user?.userId,
    password: "",
    newPassword: "",
    confirmPassword: "",
  });

  const handleClickOpen = () => {
    setOpen(true);
    setFormData({
      admin_id: user?.user_id,
      password: "",
      newPassword: "",
      confirmPassword: "",
    });
  };
  const handleClose = () => {
    console.log("formdata", formData);
    setError(null);
    setChangePassOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (name === "newPassword" || name === "confirmPassword") {
      const isValidPassword = (password) =>
        /[a-zA-Z]/.test(password) && /\d/.test(password) && password.length >= 8;

      setErrorPwd((prevErrors) => ({
        ...prevErrors,
        [name]: isValidPassword(value)
          ? ""
          : "Password must be at least 8 characters long, contain a letter, and a number.",
      }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (formData.newPassword !== formData.confirmPassword) {
      setError("New password and confirm password do not match.");
      return;
    }
    setButtonLoading(true);
    setError(null);

    // try {
    //   const response = await axiosInstance.post(
    //     "/api/dev/admin/auth/adminResetPassword",
    //     {
    //       admin_id: formData.admin_id,
    //       old_password: formData.password,
    //       new_password: formData.newPassword,
    //     }
    //   );

    //   if (response.status === 200) {
    //     Swal.fire({
    //       icon: "success",
    //       title: "Password Changed!",
    //       timer: 1500,
    //       showConfirmButton: false,
    //     });
    //     //   await axiosInstance.post("/api/dev/admin/auth/getAdminDetails",{
    //     //     "admin_id": user.user_id
    //     // });
    //     handleClose();
    //   } else {
    //     setError(error.response.data.message);
    //   }
    // } catch (error) {
    //   console.error("API call failed:", error);
    //   setError(error.response.data.message);
    // } finally {
    //   setButtonLoading(false);
    // }
  };

  const handleClickShowPassword = () => {
    const cursorPosition = inputRef.current.selectionStart;
    setShowPassword(!showPassword);

    // Wait for the state to be updated
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
        inputRef.current.focus();
      }
    }, 0);
  };

  useEffect(() => {
    // A function that sets the orientation state of the tabs.
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }

    /** 
     The event listener that's calling the handleTabsOrientation function when resizing the window.
    */
    window.addEventListener("resize", handleTabsOrientation);

    // Call the handleTabsOrientation function to set the state with the initial value.
    handleTabsOrientation();

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);

  const handleSetTabValue = (event, newValue) => setTabValue(newValue);
  const handleMouseDownPassword = (event) => event.preventDefault();

  return (
    <Dialog open={changePassOpen} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Change Password
        <span
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            padding: "10px",
            cursor: "pointer",
          }}
        >
          <CancelIcon sx={{ color: orange[500] }} onClick={handleClose} />
        </span>
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          {error && (
            <div
              className="alert alert-danger"
              role="alert"
              style={{
                fontSize: "0.8em",
                padding: "0.5em",
                borderRadius: "0.25em",
                textAlign: "center",
              }}
            >
              {error}
            </div>
          )}
          <TextField
            margin="dense"
            label="Current Password"
            name="password"
            type="password"
            required
            fullWidth
            variant="outlined"
            value={formData.password}
            onChange={handleChange}
          />
          <TextField
            margin="dense"
            label="New Password"
            name="newPassword"
            type="password"
            required
            fullWidth
            variant="outlined"
            value={formData.newPassword}
            onChange={handleChange}
            error={!!errorPwd.newPassword}
            helperText={errorPwd.newPassword}
          />
          <TextField
            margin="dense"
            label="Confirm New Password"
            name="confirmPassword"
            required
            type={showPassword ? "text" : "password"}
            fullWidth
            variant="outlined"
            value={formData.confirmPassword}
            onChange={handleChange}
            inputRef={inputRef}
            error={!!errorPwd.confirmPassword}
            helperText={errorPwd.confirmPassword}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </DialogContent>
        <DialogActions>
          <MDButton
            type="submit"
            varient="gradient"
            color="light"
            disabled={buttonLoading || errorPwd.confirmPassword || errorPwd.newPassword}
          >
            {buttonLoading ? (
              <MDBox display="flex" justifyContent="center" alignItems="center" width="100%">
                <CircularProgress sx={{ color: "#ffffff" }} size={24} />
              </MDBox>
            ) : (
              <MDTypography style={{ fontSize: "13.5px", fontWeight: "bold" }} color="white">
                Submit
              </MDTypography>
            )}
          </MDButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ChangePass;
